<div>
  <app-lista-dados
    [upTitulo]="'Lista de Postos de Combustível'"
    [upIcone]="'local_gas_station'"
    [upCor]="'3F51B5'"
    [upDados]="postos"
    [upColunas]="colunasListaDados"
    [upCarregando]="!!subscription"
    [upHabilitaEditarLinha]="true"
    [upLargura]="2"
    [upHabilitaContador]="true"
    [upHabilitaFiltroRapido]="true"
    (ueSalvarLinha)="onSalvarLinha($event)"
    (ueBotaoExcluir)="onDelete($event)">
  </app-lista-dados>
</div>

<div class="subscription" *ngIf="subscription">
  <div>
    <mat-spinner></mat-spinner>
    <p>Carregando...</p>
  </div>
</div>
